import React from 'react';
import { useLocation } from 'react-router-dom';
import { OnPitchLogo } from './OnPitchLogo';

const PAGE_TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/matches': 'Gestion des matchs',
  '/bars': 'Gestion des bars',
  '/diffusions': 'Gestion des diffusions',
  '/stories': 'Stories Instagram',
  '/logs': 'Historique des actions',
};

interface Props {
  adminName: string;
  connected: boolean;
  realtimeActive: boolean;
}

export function Header({ adminName, connected, realtimeActive }: Props) {
  const location = useLocation();
  const title = PAGE_TITLES[location.pathname] || 'ONPITCH';

  return (
    <header className="header">
      <h1 className="header-title">{title}</h1>
      <div className="header-right">
        <div className="connection-indicator">
          <span className={`conn-dot ${connected ? 'green' : 'orange'}`} />
          <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
            {connected ? 'Connecté' : 'Connexion...'}
          </span>
        </div>
        {realtimeActive && (
          <div className="connection-indicator">
            <span className="conn-dot green pulse" />
            <span style={{ fontSize: '11px', color: 'var(--green)' }}>Realtime</span>
          </div>
        )}
        <span style={{ fontSize: '13px', color: 'var(--text-muted)' }}>{adminName}</span>
      </div>
    </header>
  );
}
